// api-connector.js
import * as  refetch from 'react-refetch';
import {useKeycloak} from "@nic-react/auth";
import {useTranslation} from "@nic-react-i18n/core";

export function useAppendAuthorizationHeader() {
    const {keycloak} = useKeycloak()
    const {locale} = useTranslation()
    let auth = 'Bearer ' +  keycloak.token
    return {headers: {'Authorization': auth, 'Accept-Language': locale, 'Content-Type': 'application/json',  'charset':'utf-8'}};
}

export interface ConnectInterface {
    url?: string;
    headers: object;
}

export default refetch.connect.defaults({
    buildRequest:  (mapping: any) => {

        const {headers} = mapping;

        let url = mapping.url;
        let  options = {
            method: mapping.method,
            headers: headers,
            credentials: mapping.credentials,
            redirect: mapping.redirect,
            mode: mapping.mode,
            body: mapping.body
        };

        // console.log('CONNECT: ', url, options);

        if (url) {
            return new mapping.Request(url, options);
        }
    }
});
